<!-- E:\workspace_yongli\as_client\src\pages\system\position_level_list.vue -->
<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="表单名称">
                    <c-input name="model_name"></c-input>
                </m-search-item>
                <m-search-item label="关联流程">
                    <c-input name="process_name"></c-input>
                </m-search-item>
            </m-search>

            <c-table ref="list" height="grow">
                <c-table-column
                        label="表单名称"
                        name="model_name"
                >
                </c-table-column>

                <c-table-column
                        label="关联流程"
                        name="process_name"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_workflow_form_relate')" icon="tf-edit" @click="edit(data)">关联流程</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

            <!-- 编辑弹窗 -->
            <form-model-relate ref="formModelRelate" @resolve="$refs.list.update()"></form-model-relate>
        </module>
    </page>
</template>

<script>
import formModelRelate from "./workflow_form_model_edit.vue";

export default {
    components: {
        formModelRelate
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /************搜索列表**************/
        searchHandle(data = {}) {
            this.$refs.list.load({
                url: '/flow/form/model/list',
                data
            });
        },

        /************关联流程**************/
        edit(data) {
            this.$refs.formModelRelate.open(data);
        },


    }
}
</script>

<style lang="stylus" scoped>
</style>
